import "./HeroSection.css";
import "animate.css";

const HeroSection = () => {
  const Carousel_Img_One =
    "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735560146/web_first_c5zzmn.png";
  const Carousel_Img_Second =
    "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735560141/web_second_ofe4l4.png";
  const Carousel_Img_Third =
    "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735560138/web_third_p1dcdt.png";
  return (
    <div className="container bookshelves-container rounded text-white text-center p-4 p-md-5">
      <div className="row align-items-center">
        {/* Image Section */}
        <div className="col-12 col-md-6 text-center mb-4 mb-md-0">
          <div
            id="carouselExampleAutoplaying"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  src={Carousel_Img_One}
                  className="d-block w-100"
                  alt="..."
                />
              </div>
              <div className="carousel-item">
                <img
                  src={Carousel_Img_Second}
                  className="d-block w-100"
                  alt="..."
                />
              </div>
              <div className="carousel-item">
                <img
                  src={Carousel_Img_Third}
                  className="d-block w-100"
                  alt="..."
                />
              </div>
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleAutoplaying"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleAutoplaying"
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        {/* Text Section */}
        <div className="col-12 col-md-6 text-start">
          <h3 className="fw-bold mb-3 animate__animated animate__flipInX animate__slow	animate__repeat-3		">
            Welcome to Shine International School, Jamudag
          </h3>
          <p className="lead">
            Shine International School was established in 2014 with a handful of
            students and teachers. Over time, the school has grown to
            accommodate more than 150 students and 12 teachers. The school has
            been evolving rapidly and is flourishing toward its goals.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
